import { Component, Input, OnDestroy, OnInit, HostListener, ChangeDetectorRef, inject, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { SecureBaseComponentContext } from '../../services/secure-base-component-context.service';
import { ProductDataService, TranslationService } from '../../../../services';

@Component({
  selector: 'th[tableMultiSelectSelector], td[tableMultiSelectSelector]',
  templateUrl: './table-multi-select-selector.component.html',
  styleUrls: ['./table-multi-select-selector.component.scss'],
  standalone: false
})
export class TableMultiSelectSelectorComponent implements OnInit, AfterViewInit, OnDestroy {
  private componentContext = inject(SecureBaseComponentContext);
  private readonly translationService = inject(TranslationService);
  private productDataService = inject(ProductDataService);
  private changeDetector = inject(ChangeDetectorRef);

  @HostListener('click', ['$event'])
  onHostClick($event: Event) {
    $event.stopPropagation();
  }

  @Input() search: any;
  // @Input() search: BaseSecureSearch<SearchBaseRequest, SearchBaseResponse<any>>;

  @Input() row: any;

  isSelected = false;

  private selectAllRowsToggleSubscription: Subscription;
  private resetSelectAllRowsSubscription: Subscription;
  private searchRefreshed: Subscription;

  isVisibleRowSelection = true;

  isVisibleRowAllSelection = true;

  ngOnInit(): void {
    this.selectAllRowsToggleSubscription = this.search.selectAllRowsToggleSubject.subscribe(x => {
      this.isSelected = x;
    });
    this.resetSelectAllRowsSubscription = this.search.resetSelectAllRowsSubject.subscribe(x => {
      this.search.selectedRows = [];
    });

    this.searchRefreshed = this.search.searchRefreshed.subscribe(x => {
      this.setVisibilityCheckBoxes();
      this.search.currentSelectionCount = 0;

      if (!this.row && this.productDataService.isToggle && this.search.viewModel && this.search.viewModel.allRecords) {
        this.productDataService.isToggle = false;
        this.search.toggleAllRowsSelection(this.productDataService.isAllSelected);
        this.productDataService.isAllSelected = false;
        this.search.requestModel.paging.fetchAllRecord = false;
        this.changeDetector.detectChanges();
      }
    });

    this.setVisibilityCheckBoxes();

    this.isSelected = this.search.selectedRows.some(x => x.id == this.row.id);
  }
  ngAfterViewInit(): void {
    this.changeDetector.detectChanges();
  }
  ngOnDestroy(): void {
    if (this.selectAllRowsToggleSubscription) {
      this.selectAllRowsToggleSubscription.unsubscribe();
    }
    if (this.resetSelectAllRowsSubscription) {
      this.resetSelectAllRowsSubscription.unsubscribe();
    }

    if (this.searchRefreshed) {
      this.searchRefreshed.unsubscribe();
    }
  }

  async toggleAllRowSelection(flag: boolean) {
    if (flag && (this.search.selectedRows.length > 5000 || this.search.viewModel.allRecordsCountWithFilter > 5000)) {
      const message = this.translationService.translate(schema => schema.Messages.ErrorMessages.SelectAllRows);
      await this.componentContext.modalService.showErrorModalAsync(x => x.Messages.MessageHeadersAndActions.Error, message);
      return;
    }
    this.search.requestModel.paging.fetchAllRecord = true;
    this.productDataService.isToggle = true;
    this.productDataService.isAllSelected = flag;
    this.search.refresh();
  }

  toggleRowSelection() {
    this.search.toggleRowSelection(this.row, this.isSelected);
  }

  private setVisibilityCheckBoxes() {
    this.isVisibleRowSelection = this.row != null && this.search.isSelectionCheckBoxEnabled(this.row);
    this.isVisibleRowAllSelection = !this.row && !this.search.isEmptySelectionList();
  }
}
